import { checkOtpRequest, checkOtpResponse } from "@/types/authType";
import http from "./httpService";

export function getOtp({ mobileNumber }: { mobileNumber: string }) {
  return http
    .post(`/AccountApi/SendCode`, { mobileNumber })
    .then(({ data }) => data.data);
}

export function checkOtp({
  mobileNumber,
  confirmCode,
}: checkOtpRequest): Promise<checkOtpResponse> {
  return http
    .post(`/AccountApi/ConfirmCode`, { mobileNumber, confirmCode })
    .then(({ data }) => data.data);
}

export function resendOtp({ mobileNumber }: { mobileNumber: string }) {
  return http
    .post(`/AccountApi/ReSendCodeToPhoneNumber`, { mobileNumber })
    .then(({ data }) => data.data);
}
